import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { isNil, uniqBy } from 'lodash'

import { useInfinityScrollSimple, useResponsive } from 'hooks'
import { useModal } from 'store/slices/modals'
import { useListUserFollowersQuery } from 'store/api/yay/user'
import { User } from 'lib/_types'

import Modal from 'components/Modal/Modal'
import Loading from 'components/Loading'
import { UserList } from 'components/UserList'
import LoadMore from 'components/LoadMore'
import { UserListSearchBar } from 'pages/UserFollowingModal/UserFollowingModal'

const UserFollowerModal = () => {
  const { t } = useTranslation()
  const { isDesktop } = useResponsive()
  const modal = useModal('UserFollowerModal')

  const params = useParams()
  const userId = params?.userId

  const [__fromFollowId, __fromFollowIdSet] = useState<string>('0')
  const [__userFollowers, __userFollowersSet] = useState<Array<User>>([])
  const [currentSearch, setCurrentSearch] = useState('')

  const usersFollowersRes = useListUserFollowersQuery({
    userId,
    fromFollowId: __fromFollowId,
  })

  const loadMore = () => {
    __fromFollowIdSet(usersFollowersRes?.data?.last_follow_id?.toString?.())
  }

  const { loadMoreRef } = useInfinityScrollSimple({
    loadMore,
  })

  useEffect(() => {
    __userFollowersSet(
      uniqBy(
        [
          ...__userFollowers?.map?.((x) => {
            return (
              usersFollowersRes?.data?.users?.find?.((y) => y?.id == x?.id) ?? x
            )
          }),
          ...(usersFollowersRes?.data?.users ?? []),
        ],
        (x) => x?.id
      )
    )
  }, [usersFollowersRes])

  return (
    <Modal
      className="UserListModal"
      isActive={modal.isActive}
      onClose={() => modal.onClose()}
      title={t('common.followers')}
      fullWidth={!isDesktop}
    >
      <div>
        {usersFollowersRes?.isLoading && <Loading />}

        <UserListSearchBar
          id="UserListSearchBar"
          keyword={currentSearch}
          onChange={(s) => setCurrentSearch(s)}
          placeholderText={t('common.search_followers')}
        />

        {(__userFollowers?.length ?? 0) > 0 && (
          <div className="ConfirmBox__users ConfirmBox__users--full">
            <UserList
              users={__userFollowers}
              followFrom="follower_list"
              followCallbackSetter={__userFollowersSet}
              filterCondition={(userItem: User) =>
                userItem.nickname
                  .toLowerCase()
                  .includes(currentSearch.toLowerCase())
              }
              clickUserCallback={() => {
                modal.onClose()
              }}
            />

            <LoadMore
              isLoading={usersFollowersRes?.isLoading}
              className="ConfirmBox__users__item ConfirmBox__users__item--wide ConfirmBox__users__item--load-more"
              hidden={isNil(usersFollowersRes?.data?.last_follow_id)}
              onClick={() => {
                loadMore()
              }}
              ref={loadMoreRef}
            />
          </div>
        )}
      </div>
    </Modal>
  )
}

export default UserFollowerModal
